/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Card_Discovery_ScoreInputs */

const en_directory_card_discovery_score = /** @type {(inputs: Directory_Card_Discovery_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discovery score`)
};

const zh_directory_card_discovery_score = /** @type {(inputs: Directory_Card_Discovery_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现分`)
};

/**
* | output |
* | --- |
* | "Discovery score" |
*
* @param {Directory_Card_Discovery_ScoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_discovery_score = /** @type {((inputs?: Directory_Card_Discovery_ScoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_Discovery_ScoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_discovery_score(inputs)
	return zh_directory_card_discovery_score(inputs)
});
export { directory_card_discovery_score as "directory.card.discovery_score" }